import type { ComponentProps, ReactNode } from "react";
import { buttonVariants, Button } from "@volca/ui/components/ui/button";
import { cn } from "@volca/ui/lib/utils";

export const ActionPreview = ({
  children,
  variant,
  size = "sm",
  leftIcon,
}: {
  children: ReactNode;
  variant?: ComponentProps<typeof Button>["variant"];
  size?: ComponentProps<typeof Button>["size"];
  leftIcon?: ReactNode;
}) => (
  <span
    className={cn(
      buttonVariants({
        variant,
        size,
        className: "pointer-events-none select-none",
      }),
    )}
  >
    {leftIcon}
    {children}
  </span>
);
